/**
 * Builds audio constraints for getUserMedia calls.
 *
 * Explicitly disables browser audio processing (AGC, echo cancellation, noise
 * suppression) which interfere with clinical ambient recording: AGC causes
 * abrupt level swings, and echo cancellation / noise suppression distort
 * single-speaker audio that isn't a two-party call. Mic-level previews use the
 * same constraints so the preview reflects the actual recording signal.
 */
export const getAudioConstraints = (
  deviceId?: string,
): MediaStreamConstraints => ({
  video: false,
  audio: {
    ...(deviceId ? { deviceId: { exact: deviceId } } : {}),
    echoCancellation: false,
    noiseSuppression: false,
    autoGainControl: false,
    // Ask for the rate/channel layout the encode pipeline is built around
    // (48kHz Opus, mono). `ideal` never over-constrains: browsers that can't
    // honor it return the closest supported settings, and the capture path
    // resamples via AudioContext — this just avoids the resample when the
    // hardware can capture natively.
    sampleRate: { ideal: 48_000 },
    channelCount: { ideal: 1 },
  },
});
